import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicBadge from "./BasicBadge";

const BadgePage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Badge"}
        description={
          "Badge generates a small badge to the top-right of its child(ren)."
        }
      />
      <Divider light />

      <BasicBadge />
    </Paper>
  );
};

export default BadgePage;
